function AdminSectorHeader({ sector, title, description, metric, metricLabel, detail, onBack }) {
  return (
    <header style={{ position: "relative", overflow: "hidden", background: "linear-gradient(118deg, #123763 0%, #0b5ed7 78%, #316be6 100%)", color: "#fff", borderRadius: 18, padding: "clamp(20px, 2.5vw, 34px)", marginBottom: 16, boxShadow: "0 16px 36px rgba(13,57,118,0.18)" }}>
      <div aria-hidden="true" style={{ position: "absolute", right: -80, bottom: -130, width: 360, height: 360, borderRadius: "50%", border: "1px solid rgba(255,255,255,0.18)", background: "rgba(255,255,255,0.05)" }} />
      <div style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 20, flexWrap: "wrap" }}>
        <div style={{ maxWidth: 760 }}>
          <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1.5, textTransform: "uppercase", opacity: 0.82 }}>Painel administrativo · {sector}</div>
          <h1 style={{ margin: "7px 0 6px", fontSize: "clamp(25px, 3vw, 38px)", lineHeight: 1.12 }}>{title}</h1>
          {description && <div style={{ fontSize: 14, lineHeight: 1.5, opacity: 0.88 }}>{description}</div>}
          {detail && <div style={{ marginTop: 10, fontSize: 13, fontWeight: 700, opacity: 0.95 }}>{detail}</div>}
          {onBack && <button type="button" onClick={onBack} style={{ marginTop: 16, border: "1px solid rgba(255,255,255,0.45)", borderRadius: 9, padding: "9px 14px", background: "rgba(255,255,255,0.14)", color: "#fff", fontWeight: 800, cursor: "pointer" }}>Voltar ao painel</button>}
        </div>
        {metric !== undefined && (
          <div style={{ minWidth: 130, padding: "13px 16px", border: "1px solid rgba(255,255,255,0.25)", borderRadius: 14, background: "rgba(255,255,255,0.13)" }}>
            <div style={{ fontSize: 28, fontWeight: 900, lineHeight: 1 }}>{metric}</div>
            <div style={{ marginTop: 6, fontSize: 12, fontWeight: 700, opacity: 0.9 }}>{metricLabel}</div>
          </div>
        )}
      </div>
    </header>
  );
}

export default AdminSectorHeader;
